import { handleize } from "./convertCase";
import { generateImageUrl, generateImageSrcset } from "./imageUrls";
import template from "lodash.template";

/**
 * @description Notes
 * showPackshot setting only works for one packshot,
 * Which means it doesn't work correct with swatches ATM. It's only used by power step.
 * For now, it's fine.
 */

export default function compileProductCardTemplate(
  product,
  variant,
  templates,
  settings = {}
) {
  if (templates.productCardTemplate && templates.productCardMediaItemTemplate) {
    // Get templates
    const productCardMarkup = templates.productCardTemplate.innerHTML.trim();
    const productCardMediaItemMarkup =
      templates.productCardMediaItemTemplate.innerHTML.trim();

    const swatchMarkup = templates.swatchTemplate
      ? templates.swatchTemplate.innerHTML.trim()
      : null;
    const swatchItemMarkup = templates.swatchItemTemplate
      ? templates.swatchItemTemplate.innerHTML.trim()
      : null;

    const currentVariant = variant;

    // Get color option index
    let colorOptionIndex = -1;

    if (product && product.options) {
      for (let i = 0; i < product.options.length; i++) {
        if (product.options[i].name === "Color") {
          colorOptionIndex = i + 1;
          break;
        }
      }
    }

    // Setup grid general media options
    let gridClasses = "ss-grid__item--4-of-8 ss-grid__item--2-of-8-md";
    let productCardClasses = "";
    let mediaClass = "";
    let mediaSizes = "(max-width: 1023px) 50vw, 25vw";
    let wideSet = false;
    let wideSetMobile = false;

    productCardClasses += templates.productCardTemplate.dataset.cardVariant
      ? templates.productCardTemplate.dataset.cardVariant
      : "";
    mediaClass = templates.productCardMediaItemTemplate.dataset.mediaVariant
      ? templates.productCardMediaItemTemplate.dataset.mediaVariant
      : "media--product-card";

    if (
      product &&
      product.vendor &&
      (handleize(product.vendor) === "mos-mosh-gallery" ||
        handleize(product.vendor) === "gallery")
    ) {
      productCardClasses += " theme--theme-man";
    }

    // Setup swatch
    let swatch = "";
    let swatchItems = "";
    let swatchActiveIndex = 0;

    const currentVariantColor =
      currentVariant && colorOptionIndex
        ? currentVariant["option" + colorOptionIndex]
        : null;

    if (product && product.colors) {
      for (let i = 0; i < product.colors.length; i++) {
        let classes = "";

        if (product.colors[i] === currentVariantColor) {
          swatchActiveIndex = i;
          classes = "active";
        }

        if (swatchItemMarkup) {
          const swatchItemTemplate = template(swatchItemMarkup);

          swatchItems += swatchItemTemplate({
            classes: classes,
            swatch_color: product.colors[i],
          });
        }
      }
    }

    if (swatchItems.length > 0 && swatchMarkup) {
      const swatchTemplate = template(swatchMarkup);

      swatch = swatchTemplate({
        swatch_items: swatchItems,
      });
    }

    // Setup media items

    let modelshotIndex;
    let packshotFrontIndex;

    if (product && product.medias) {
      for (const [index, media] of product.medias.entries()) {
        const mediaAltType = media.alt.split("/")[0].trim().toLowerCase();
        const mediaAltColor = media.alt.split("/")[1]
          ? media.alt.split("/")[1].trim().toLowerCase()
          : "";
        const mediaAltAngle = media.alt.split("/")[2]
          ? media.alt.split("/")[2].trim().toLowerCase()
          : "";
        if (
          !modelshotIndex &&
          mediaAltType === "modelshot" &&
          product.colors.length &&
          currentVariantColor &&
          mediaAltColor === currentVariantColor.toLowerCase()
        ) {
          modelshotIndex = index;
        }
        if (
          !packshotFrontIndex &&
          mediaAltType === "packshot" &&
          mediaAltColor === currentVariantColor &&
          currentVariantColor.toLowerCase() &&
          mediaAltAngle === "front"
        ) {
          packshotFrontIndex = index;
        }
      }
    }

    let mediaItems = "";
    let mediaItemArray = [];

    let defaultImageAlt = "";
    let defaultImageSrcset = "";
    let defaultImageUrl = "";

    defaultImageAlt = currentVariant.image_alt;
    defaultImageSrcset = generateImageSrcset(currentVariant.image_url);
    defaultImageUrl = generateImageUrl(currentVariant.image_url);

    if (settings.showPackshot) {
      if (product && product.medias && product.medias[packshotFrontIndex]) {
        defaultImageAlt = product.medias[packshotFrontIndex].alt;
        defaultImageSrcset = generateImageSrcset(
          product.medias[packshotFrontIndex].url
        );
        defaultImageUrl = generateImageUrl(
          product.medias[packshotFrontIndex].url
        );
      }

      mediaItemArray.push({
        imageAlt: defaultImageAlt,
        imageSrcset: defaultImageSrcset,
        imageUrl: defaultImageUrl,
      });
    } else {
      if (!defaultImageUrl) {
        defaultImageAlt = product.image_alt;
        defaultImageSrcset = generateImageSrcset(product.image_url);
        defaultImageUrl = generateImageUrl(product.image_url);
      }

      if (product && product.colors && product.colors.length > 1) {
        for (let i = 0; i < product.colors.length; i++) {
          let colorImageAlt = "";
          let colorImageSrcset = "";
          let colorImageUrl = "";

          for (let j = 0; j < product.variants.length; j++) {
            const { image_alt, image_url } = product.variants[j];

            if (
              product.variants[j][`option${colorOptionIndex}`] ===
              product.colors[i]
            ) {
              colorImageAlt = image_alt;
              colorImageSrcset = generateImageSrcset(image_url);
              colorImageUrl = generateImageUrl(image_url);
              break;
            }
          }

          if (colorImageUrl === "") {
            //If non found
            colorImageAlt = defaultImageAlt;
            colorImageSrcset = defaultImageSrcset;
            colorImageUrl = defaultImageUrl;
          }

          mediaItemArray.push({
            imageAlt: colorImageAlt,
            imageSrcset: colorImageSrcset,
            imageUrl: colorImageUrl,
          });
        }
      } else {
        mediaItemArray = [
          {
            imageAlt: defaultImageAlt,
            imageSrcset: defaultImageSrcset,
            imageUrl: defaultImageUrl,
          },
        ];
      }
    }

    for (let i = 0; i < mediaItemArray.length; i++) {
      const mediaItemTemplate = template(productCardMediaItemMarkup);

      let objectPosition = "center center";
      let mediaItemClass = mediaClass;

      if (
        product.grid_image_alignment !== "middle" &&
        mediaItemArray[i].imageAlt &&
        mediaItemArray[i].imageAlt.toLowerCase().indexOf("packshot") === -1
      ) {
        mediaItemClass += " media--align-" + product.grid_image_alignment;

        if (product.grid_image_alignment === "top") {
          objectPosition = "center 25%";
        }

        if (product.grid_image_alignment === "bottom") {
          objectPosition = "center 75%";
        }
      }

      mediaItems += mediaItemTemplate({
        display_class:
          i === swatchActiveIndex || settings.showPackshot ? "" : " hidden",
        image_alt: mediaItemArray[i].imageAlt,
        image_sizes: mediaSizes,
        image_srcset: mediaItemArray[i].imageSrcset,
        image_url: mediaItemArray[i].imageUrl,
        video_url: null,
        video_mime_type: null,
        video_alt: null,
        video_preview_image: null,
        media_class: mediaItemClass,
        object_position: objectPosition,
      });
    }

    // Setup tags
    let newTag = "";
    let sustainableTag = "";
    let c2sTag = "";
    let c2s = false;
    let exclusivesTag = "";
    let webOnlyTag = "";
    let labels = "";

    if (!settings.hideTags) {
      c2s = product.tags.includes("c2s");
      c2sTag = product.tags.includes("c2s")
        ? `<p class="text-tag-3 product-card__tag">${templates.productCardTemplate.dataset.textC2s}</p>`
        : "";

      if (product.labels) {
        labels = product.labels
          .map((label) => {
            if (label === "New" && product.tags.includes("c2s")) {
              return "";
            }
            return `<p class="text-tag-3 product-card__tag">${label}</p>`;
          })
          .join("");
      }

      sustainableTag = product["SU_2"] ? product["SU_2"].join(" - ") : "&nbsp;";

      exclusivesTag =
        String(product.tags).toLowerCase().includes("exclusives") ||
        product.tags.includes(window.mosmosh.translations.product.exclusives)
          ? `<p class="text-tag-3 product-card__tag" style="background:yellow >${
              templates.productCardTemplate.dataset.textExclusives ||
              "Exclusives"
            }</p>`
          : "";

      webOnlyTag = String(product.tags).toLowerCase().includes("web only")
        ? `<p class="text-tag-3 product-card__tag">Web only</p>`
        : "";
    }

    let hcSaleTag = "";

    if (
      product.available &&
      product.compare_at_price_min > product.price_min &&
      !product.tags.includes("c2s")
    ) {
      let discount =
        ((product.compare_at_price_min - product.price_min) * 100) /
        product.compare_at_price_min;
      if (discount != undefined) {
        hcSaleTag =
          '<div class="hc-sale-tag"><span>' +
          discount.toFixed(0) +
          "%</span></div>";
      }
    }

    // Setup price
    let price = currentVariant.price;

    if (currentVariant.compare_at_price && !c2s) {
      price =
        `<span class="product-card__original-price">${currentVariant.compare_at_price}</span>` +
        price;
    }

    //Set sale status
    const isOnSale = c2s
      ? false
      : parseInt(currentVariant.compare_at_price_in_hundreds) >
        parseInt(currentVariant.price_in_hundreds);

    if (isOnSale) {
      productCardClasses += " sale";
    }

    // Setup URL
    let currentUrl = `/products/${product.handle}?variant=${currentVariant.id}`;

    if (settings.preselectURL) {
      currentUrl += `&preselect=1`;
    }

    //Find index of first 'modelshot' for product
    const hoverMediaItemTemplate = template(productCardMediaItemMarkup);

    let hoverImage = product.medias.find((image) => {
      const altSplit = image.alt?.toLowerCase().split("/");

      if (altSplit && altSplit.length === 3) {
        const altType = altSplit[0].trim();
        const altColor = altSplit[1].trim();
        const altPos = altSplit[2].trim();

        return (
          image.type === "image" &&
          altColor === currentVariantColor?.toLowerCase() &&
          altType === "packshot" &&
          altPos === "front"
        );
      }
      return false;
    });

    if (!hoverImage) {
      hoverImage = product.medias.find((image) => {
        const altSplit = image.alt?.toLowerCase().split("/");

        if (altSplit && altSplit.length === 3) {
          const altType = altSplit[0].trim();
          const altColor = altSplit[1].trim();
          const altPos = altSplit[2].trim();

          return (
            image.type === "image" &&
            altColor === currentVariantColor?.toLowerCase() &&
            altType === "modelshot" &&
            altPos === "front"
          );
        }
        return false;
      });
    }

    let hoverMediaItem = hoverImage
      ? hoverMediaItemTemplate({
          display_class: " hover",
          image_alt: hoverImage.alt,
          image_sizes: mediaSizes,
          image_srcset: generateImageSrcset(hoverImage.url),
          image_url: generateImageSrcset(hoverImage.url),
          video_url: null,
          video_mime_type: null,
          video_alt: null,
          video_preview_image: null,
          media_class: mediaClass,
          object_position: "center center",
        })
      : null;

    if (settings.showVideoHover) {
      const video = product.video.find((vid) => {
        const altSplit = vid.media_alt?.toLowerCase().split("/");

        if (altSplit && altSplit.length > 2) {
          const altColor = altSplit[1].trim();

          return altColor === currentVariantColor.toLowerCase();
        }
        return false;
      });

      if (video) {
        hoverMediaItem = hoverMediaItemTemplate({
          display_class: " hover",
          image_alt:
            product && product.medias && product.medias[modelshotIndex]
              ? product.medias[modelshotIndex].alt
              : null,
          image_sizes: mediaSizes,
          image_srcset: generateImageSrcset(
            product &&
              product.medias &&
              product.medias[modelshotIndex] &&
              product.medias[modelshotIndex].url
              ? product.medias[modelshotIndex].url
              : null
          ),
          image_url: generateImageSrcset(
            product && product.medias && product.medias[modelshotIndex]
              ? product.medias[modelshotIndex].url
              : null
          ),
          video_url:
            video.media_sources &&
            video.media_sources[video.media_sources.length - 1]
              ? video.media_sources[video.media_sources.length - 1].media_url
              : null,
          video_mime_type:
            video.media_sources &&
            video.media_sources[video.media_sources.length - 1]
              ? video.media_sources[video.media_sources.length - 1]
                  .media_mime_type
              : null,
          video_alt: video.media_alt,
          video_preview_image: video.media_preview,
          media_class: mediaClass,
          object_position: "center center",
        });
      }
    }

    // Build product card template
    const compiledTemplate = template(productCardMarkup);

    return compiledTemplate({
      grid_classes: gridClasses,
      json: JSON.stringify(product),
      media_items: mediaItems,
      media_hover: hoverMediaItem,
      price: price,
      product_card_classes: productCardClasses,
      c2s_tag: c2sTag,
      c2s: c2s,
      labels: labels,
      sustainable_tag: sustainableTag,
      exclusives_tag: exclusivesTag,
      web_only_tag: webOnlyTag,
      swatch: swatch,
      vendor: product.vendor,
      title: product.title,
      url: currentUrl,
      hc_sale_tag: hcSaleTag,
    });
  }
}
